import EzController from 'controllers/ez-base-controller';
import { parseBoolean, snakeToCamelCase } from 'lib/helpers';
import { sendTrackingEvent, TrackingEvent, TrackingData } from 'components/analytics/conversions/tracking';

type EventParams = {
  action?: string,
  label?: string,
  value?: string,
  sendFromBody: string|boolean,
  params: Record<string, unknown>
};

export default class TrackEventController extends EzController {
  declare includeDataValue:string;

  declare readonly hasIncludeDataValue:boolean;

  static values = {
    includeData: String,
  };

  track(event: { currentTarget: HTMLElement, params: EventParams }) {
    const {
      action,
      label,
      value,
      sendFromBody = false,
      ...params
    }: EventParams = event.params;

    if (action === undefined) return;

    const payload: TrackingData = {
      action,
    };

    if (label !== undefined) payload.label = label;
    if (value !== undefined) payload.value = value;

    Object.assign(payload, params);
    Object.assign(payload, this.processIncludedData());

    const trackedEvent: TrackingEvent = { data: payload };
    if (parseBoolean(sendFromBody) !== true) {
      trackedEvent.element = event.currentTarget as HTMLElement;
    }

    sendTrackingEvent(trackedEvent);
  }

  processIncludedData() {
    if (!this.hasIncludeDataValue) return {};

    const data = {};
    const values = this.includeDataValue.split(',').map((i) => i.trim());

    values.forEach((value) => {
      data[value] = (this.element as HTMLElement).dataset[snakeToCamelCase(value)];
    });

    return data;
  }
}
